import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import BaseModal from '../../BaseModal';
import {
  clearPerformanceModalFilters,
  setPerformanceModals,
} from '@/store/slices/components/dashboard/DashboardSlice';
import buildQuery from '@/components/Dashboard/utils/buildQuery';
import { getPerformancePropertyConsultationsTable } from '@/store/slices/components/dashboard/service';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import DownloadButton from '@/components/Dashboard/DashboardTables/components/DownloadButton';
import styles from '../../performanceModals.module.scss';
import buildTableQuery from '@/components/Dashboard/utils/buildTableQuery';
import useAsyncTableExcelDownload from '@/components/Dashboard/customHooks/useAsyncTableExcelDownload';
import { TABLES } from '@/components/Dashboard/constants';
import TableSearchEmptyState from '@/components/Dashboard/DashboardTables/TableSearchEmptyState';
import SearchInput from '../../SearchInput';
import { propertyConsultationsTypesOptions } from '../utils';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import PropertyConsultationsTable from '@/components/Dashboard/DashboardTables/PropertyConsultationsTable';

export default function PropertyConsultationsModal() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { propertyConsultations } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const {
    count,
    list,
    loading,
    sortBy,
    sortDirection,
    searchQuery,
    searchTypeFlag,
  } = propertyConsultations;
  const track = useTrackPerformanceTable();
  const { handleDownloadExcel: downloadExcel, isDownloading } =
    useAsyncTableExcelDownload(TABLES.PROPERTY_CONSULTATIONS);

  useEffect(() => {
    const fetchData = () => {
      const query = buildQuery(selectedIds);
      const tableQuery = buildTableQuery(propertyConsultations);

      dispatch(getPerformancePropertyConsultationsTable({ query, tableQuery }));
    };

    fetchData();
  }, [sortBy, sortDirection, searchQuery, searchTypeFlag]);

  const handleDownloadExcel = () => {
    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(propertyConsultations);
    downloadExcel(query, tableQuery);
    track.propertyConsultations(TRACK_ELEMENT.DOWNLOAD_BUTTON);
  };

  const handleClearFilters = () => {
    const modal = 'propertyConsultations';
    const filters = ['searchQuery', 'searchType'];
    dispatch(clearPerformanceModalFilters({ modal, filters }));
  };

  return (
    <BaseModal
      id="property-consultations-modal"
      title={`${count} ${Trans(
        translations,
        'DashboardTableTitle.PropertyInquiries'
      )}`}
      handleClose={() =>
        dispatch(
          setPerformanceModals({
            key: 'propertyConsultations',
            subkey: 'isOpen',
            value: false,
          })
        )
      }
    >
      <Box className={styles.modalControls}>
        <SearchInput
          modal="propertyConsultations"
          dropdownOptions={propertyConsultationsTypesOptions}
        />

        <DownloadButton
          onClick={handleDownloadExcel}
          disabled={isDownloading}
        />
      </Box>
      {searchQuery && list?.length === 0 && !loading ? (
        <TableSearchEmptyState onClearFilters={handleClearFilters} />
      ) : (
        <BaseModal.TableContainer>
          <PropertyConsultationsTable />
        </BaseModal.TableContainer>
      )}
    </BaseModal>
  );
}
